export default {
  data: () => ({ assetMobile: window.innerWidth <= 768 }),
  mounted() {
    this.updateAssetViewport()
    window.addEventListener('resize', this.updateAssetViewport)
  },
  activated() { this.updateAssetViewport() },
  beforeDestroy() { window.removeEventListener('resize', this.updateAssetViewport) },
  methods: {
    updateAssetViewport() {
      this.assetMobile = window.innerWidth <= 768
      if (this.assetMobile && this.$route.path.startsWith('/assets/') && !this.$store.getters.collapse) {
        this.$store.dispatch('setCollapse', true)
      }
    }
  }
}
